import { CanDeactivateFn } from '@angular/router';
import { CanDeactivateInterface } from '../../interfaces/can-deactivate-interface';

export const unsavedChangesGuard: CanDeactivateFn<CanDeactivateInterface> = (
  component,
  currentRoute,
  currentState,
  nextState
) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};